<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
  <el-breadcrumb-item>绩效查看</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
  
  <el-row>
      <el-col :span="12">
          时间：
<el-select v-model="value" placeholder="考核年份">
        <el-option
          v-for="item in year"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="value3" placeholder="考核月份">
        <el-option
          label="无"
          value="0">
        </el-option>
        <el-option
          v-for="item in moun"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
  </el-col>
<el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="getPerformance">查询</el-button></div></el-col>
</el-row>
<el-table
  ref="multipleTable"
  :data="viewList"
  border
  show-overflow-tooltip="true"
  tooltip-effect="dark"
  style="width: 100%"
  >
  <el-table-column
    label="工号"
    width="120"
    :show-overflow-tooltip="true"
    prop="work_number">
    
  </el-table-column>

  <el-table-column
    label="姓名"
    width="120"
    :show-overflow-tooltip="true"
    prop="user_name">
  </el-table-column>
  <el-table-column
      label="服务学院教学和日常运行"
      width="120"
      :show-overflow-tooltip="true"
      prop="teaching_operation">
    </el-table-column>
    <el-table-column
      label="服从学院各项工作安排时"
      width="120"
      :show-overflow-tooltip="true"
      prop="obey_arrange">
    </el-table-column>
    <el-table-column
      label="全英文交流"
      width="190"
      :show-overflow-tooltip="true"
      prop="english_exchange">
    </el-table-column>
    <el-table-column
      label="与英方合作团队保持有效工作沟通"
      width="120"
      :show-overflow-tooltip="true"
      prop="cooperation_exchange">
    </el-table-column>
    <el-table-column
      label="学生、家长或学院其他部门投诉"
      width="120"
      :show-overflow-tooltip="true"
      prop="user_complaints">
    </el-table-column>
  <el-table-column
    label="绩效"
    width="120"
    :show-overflow-tooltip="true"
    prop="perf"
    :formatter="perfFormatter">
  </el-table-column>
  <el-table-column
    label="绩效时间"
    width="120"
    :show-overflow-tooltip="true"
    prop="write_date"
    :formatter="writeDateFormatter">
  </el-table-column>
  <el-table-column
    label="生成时间"
    width="120"
    :show-overflow-tooltip="true"
    prop="create_time"
    :formatter="createTimeFormatter">
  </el-table-column>
</el-table>
<div class="block">
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage4"
    :page-sizes="[10, 20, 30, 40]"
    :page-size="10"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
</div>

</el-card>




</div>
</template>

<script>
export default {
created(){
  this.getYearDateList()
  this.getMonthlIST()
  this.getPerformance()
},
data(){
  return{
      year:[],
      moun:[],
      userType:'getTPerformance',
      value: '',
      value3: '',
      viewList:[],
      formData:{
          particulars:'',
          fileList7:[],
        fileList8:[],
        fileList:[],
          is_public:false,
          file:null
      },
      querys:{
       writeDate:null,
        pageNum:null,
        pageSize:null,
        isWeeks:4,
        isYear:'false'
      },
      total:null,
      currentPage4: 1,
  }
},methods:{
  handleSizeChange(val) {
      if(val!=null||val!=''){
        this.querys.pageSize=val
      }
      console.log(`每页 ${val} 条`);
      this.getPerformance()
    },
    handleCurrentChange(val) {
      if(val!=null||val!=''){
        this.querys.pageNum=val
      }
      console.log(`当前页: ${val}`);
      this.getPerformance()
    },
  getPerformance(){
    let moundVal=0;
    if(this.value3=='0'){  
      this.querys.isYear='true'
      moundVal=1
    }else{
      this.querys.isYear='false'
      moundVal=this.value3
    }
      let kpidate=this.value+'-'+(moundVal>9?moundVal:'0'+moundVal)
      this.querys.writeDate=kpidate
  this.axios.get("/performance/getAPerf"+this.$formateDate.tansParams(this.querys))
           .then(resp=>{
            console.log(resp)
            if(resp.data.status==1){
              console.log(resp.data.result)
              this.total=resp.data.result.total
              this.viewList=resp.data.result.rows
              console.log('this.viewList',this.viewList)
            }
           })
},perfFormatter(row,column,cellValue,index){
   let datas= cellValue*100+'%'
  return datas
  },writeDateFormatter(row,column,cellValue){
  var date =	new Date(cellValue);
 let year= date.getFullYear()
 let month= date.getMonth()+1
return year+'/'+month
},createTimeFormatter(row,column,cellValue){
  var date =	new Date(cellValue).toLocaleString();
 
return date
},
getYearDateList(){
    var date = new Date()
  var Y = date.getFullYear()
 let yearList=[]
 yearList.push(Y-1)
 yearList.push(Y)
 yearList.push(Y+1)
  this.value=Y
 this.year=yearList
     },   getMonthlIST(){
      var date = new Date()
      var M = (date.getMonth() + 1)
      if(M!=1){
        this.value3=M-1
      }
      let mounList=[]
      for (let index = 1; index <13; index++) {
      mounList.push(index)  
      }
    this.moun=mounList
    // this.value3=M
     },

    
    
    
}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/administrative/viewMonthAPerformance.vue